module.exports = __webpack_public_path__ + "img/advice-5.8d9376da.png";